import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import moment from 'moment';

// Components
import { Search, Button } from 'carbon-components-react';
import GlobalRegistriesGrid from './GlobalRegistriesGrid';

// data


const GlobalRegistriesContent = ({
  globalRegistriesList,
  setOpenNewGlobalRegistryModal,
  setMode,
  user,
  setTriggerExport,
  triggerExport,
  onDeleteClicked,
  setDetailModalMode,
  setGlobalRegistry,
  onGenerateReport,
  reportStatus,
}) => {
  const [search, setSearch] = useState("");
  const onlyAttachment = localStorage.getItem('only_attachment')

  const rowClicked = (data) => {
    setDetailModalMode("update")
    setGlobalRegistry(data);
    setOpenNewGlobalRegistryModal(true)
  }

  return (
    <Container>
      <ContentHeader>
        <ActionBar>
            <div style={{ width: "300px" }}>
              <Search
                size="sm"
                value={search}
                labelText="search"
                onChange={e => setSearch(e.target.value)}
                placeHolderText="Search using any data value"
              />
            </div>

            <ButtonGroup>
              <Button
                kind="secondary"
                onClick={onGenerateReport}
                disabled={reportStatus === 'polling'}
                style={addStudyBtnStyle}
              >{reportStatus === 'polling' ? 'Generating...' : 'Generate Report'}</Button>
              <Button
                kind="primary"
                onClick={() => {
                  setOpenNewGlobalRegistryModal(true);
                  setMode("create");
                }}
                style={addStudyBtnStyle}
                disabled={onlyAttachment === "true"}
              >
              Add New Global Registry
              </Button>
            </ButtonGroup>
          </ActionBar>
      </ContentHeader>
    
      <GlobalRegistriesGridContainer>
        <GlobalRegistriesGrid
          user={user}
          search={search}
          globalRegistriesList={globalRegistriesList} 
          setTriggerExport={setTriggerExport}
          triggerExport={triggerExport}
          onDeleteClicked={onDeleteClicked}
          onRowClicked={rowClicked}
          />
      </GlobalRegistriesGridContainer>


    </Container>
  );
};

export default GlobalRegistriesContent;


const GlobalRegistriesGridContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
`

const ActionBar = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const addStudyBtnStyle = {
  padding: "11px 18px",
  height: "auto",
  minHeight: "unset",
  borderRadius: "10px",
  fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
  fontWeight: 700,
  fontSize: "13.5px",
};

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
  background-color: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0,0,0,.04);
  padding: 22px 24px;
`

const ContentHeader = styled.div`
  flex: 0 1 auto;
`

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`